import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'payment_form';
export const route = 'payment_form/[shoppingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "payment_form_page" */
/* webpackPrefetch: true */
'../components/PaymentForm')));